import { h } from '@/lib/dom';
import { attemptLogin } from '@/lib/data';
import { setSessionUser } from '@/lib/session';
import { toast } from '@/components/Toast';
import { navigate } from '@/router';
import type { RouteContext } from '@/router';
import { Button } from '@/components/Button';
import { FormField } from '@/components/FormField';

export async function renderLogin(_ctx: RouteContext): Promise<Node> {
  const root = h('div', { class: 'login-container' });

  let loading = false;
  let error: string | null = null;

  const render = (): void => {
    root.innerHTML = '';
    root.appendChild(loginCard());
  };

  function loginCard(): HTMLElement {
    const usernameInput = h('input', {
      class: 'form-input',
      type: 'text',
      id: 'username',
      name: 'username',
      autocomplete: 'username',
      required: true,
    }) as HTMLInputElement;

    const passwordInput = h('input', {
      class: 'form-input',
      type: 'password',
      id: 'password',
      name: 'password',
      autocomplete: 'current-password',
      required: true,
    }) as HTMLInputElement;

    const totpInput = h('input', {
      class: 'form-input',
      type: 'text',
      id: 'totp',
      name: 'totp',
      inputmode: 'numeric',
      autocomplete: 'one-time-code',
      maxlength: 6,
      placeholder: '000000',
    }) as HTMLInputElement;

    const totpField = h('div', { class: 'form-field' }, [
      h('label', { class: 'form-label', for: 'totp' }, [
        'Код из Authenticator ',
        h('em', { class: 'form-label-hint' }, '— только Ивану'),
      ]),
      totpInput,
    ]);

    const submitBtn = Button({
      label: loading ? 'Проверяем…' : 'Войти',
      variant: 'primary',
      type: 'submit',
      disabled: loading,
    });
    submitBtn.classList.add('login-submit-btn');

    const submitRow = h('div', { class: 'login-submit-row' }, [submitBtn]);

    const form = h('form', {
      on: {
        submit: async (ev: Event) => {
          ev.preventDefault();
          const username = usernameInput.value.trim();
          const password = passwordInput.value;
          const totp = totpInput.value.trim() || undefined;
          if (!username || !password) return;
          loading = true;
          error = null;
          render();
          try {
            const user = await attemptLogin(username, password, totp ?? '');
            setSessionUser(user);
            toast('Вход выполнен', { type: 'success', duration: 2000 });
            const next = new URLSearchParams(window.location.search).get('next') || '/';
            navigate(next, { replace: true });
          } catch (err) {
            loading = false;
            error = err instanceof Error ? err.message : 'Не удалось войти';
            render();
          }
        },
      },
    }, [
      FormField({
        label: 'Логин',
        htmlFor: 'username',
        children: usernameInput,
        required: true,
      }),
      FormField({
        label: 'Пароль',
        htmlFor: 'password',
        children: passwordInput,
        required: true,
      }),
      totpField,
      submitRow,
    ]) as HTMLFormElement;

    return h('div', { class: 'login-card', role: 'main' }, [
      h('div', { class: 'login-brand' }, [
        h('img', {
          src: '/favicon.svg',
          class: 'login-logo',
          alt: '',
          'aria-hidden': 'true',
        }),
        h('span', { class: 'login-brand-name' }, 'Health Dashboard'),
      ]),
      error
        ? h('div', { class: 'login-error', role: 'alert', 'aria-live': 'polite' }, [
            h('span', { class: 'login-error-icon', 'aria-hidden': 'true' }, '⚠'),
            h('span', null, error),
          ])
        : null,
      form,
      h('p', { class: 'login-footer' }, 'Защищено HTTPS · Только для Ивана и его врача'),
    ]);
  }

  render();
  return root;
}
